import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Find Doctors', path: '/doctors' },
    { name: 'Blog', path: '/blog' },
  ];

  const specialties = [
    'Dentist', 'Gynecologist', 'Dermatologist', 'Cardiologist',
    'Pediatrician', 'Orthopedic', 'Psychiatrist', 'Physiotherapist',
    'Psychotherapist', 'Nutritionist', 'Diabetologist', 'Homeopathy',
    'ENT Specialist', 'Occupational Therapist', 'General Physician', 'Radiologist',
  ];

  return (
    <footer style={{ background: '#19354a', color: '#fff' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '48px 24px 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 32 }}>

          {/* Col 1: About + Map */}
          <div>
            <h3 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 12px' }}>Docmize</h3>
            <p style={{ color: '#b0c4d4', fontSize: 13, lineHeight: 1.7, margin: '0 0 16px' }}>
              India's leading healthcare platform. Book appointments with verified doctors, get online consultations, and manage your health records.
            </p>
            <div style={{ width: '100%', height: 180, borderRadius: 8, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.956789!2d77.0147381!3d28.4897609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a8ed6c3d8fdbcbf%3A0xe3e39996315bc6d2!2sDocmize%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1738483200000!5m2!1sen!2sin"
                width="100%" height="100%"
                style={{ border: 0, display: 'block' }}
                allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Docmize Office Location"
              />
            </div>
          </div>

          {/* Col 2: Quick Links + Contact */}
          <div>
            <h4 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 14px' }}>Quick Links</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px' }}>
              {quickLinks.map((link) => (
                <li key={link.path} style={{ marginBottom: 8 }}>
                  <Link to={link.path} style={{ color: '#b0c4d4', fontSize: 13, textDecoration: 'none' }}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div style={{ fontSize: 13, color: '#b0c4d4', lineHeight: 1.9 }}>
              <p style={{ margin: '0 0 4px' }}>📞 <a href="tel:+918920845297" style={{ color: '#b0c4d4', textDecoration: 'none' }}>+91 8920845297</a></p>
              <p style={{ margin: 0 }}>✉️ <a href="mailto:appointment@docmize.in" style={{ color: '#b0c4d4', textDecoration: 'none' }}>appointment@docmize.in</a></p>
            </div>
          </div>

          {/* Col 3: Top Specialties */}
          <div>
            <h4 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 14px' }}>Top Specialties</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {specialties.slice(0, 8).map((s) => (
                <li key={s} style={{ marginBottom: 8 }}>
                  <Link to={`/doctors?specialty=${s}`} style={{ color: '#b0c4d4', fontSize: 13, textDecoration: 'none' }}>{s}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: More Specialties */}
          <div>
            <h4 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 14px', color: 'transparent', userSelect: 'none' }}>.</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {specialties.slice(8).map((s) => (
                <li key={s} style={{ marginBottom: 8 }}>
                  <Link to={`/doctors?specialty=${s}`} style={{ color: '#b0c4d4', fontSize: 13, textDecoration: 'none' }}>{s}</Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 40, paddingTop: 20, textAlign: 'center' }}>
          <p style={{ color: '#7a9bb5', fontSize: 13, margin: 0 }}>
            © {new Date().getFullYear()} Docmize. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;